export const STRIPE_API_KEY = "pk_test_ap3rU3FsslBpyR3SjMF2fNLD000Fjo54oX";
// export const STRIPE_API_KEY = "pk_live_51HKV3DIAY1lWYhpMw0VDOVhgbjow4Ki8sZQbxhIQPqi497A70i1rfkGGIixKqDDjP1jv14Vxx2ovzAJ1HDLiN38h00rLGcrWgB";

export const RECAPTCHA_V2_SITE_KEY = "6Lf9aMkZAAAAANoVm9V_7qYe35eXO2M70SJXeddn";
